// The weighing-scale layout stored in tenant_settings.scale_barcode (JSON),
// read back into core's ScaleConfig.
import { DEFAULT_SCALE_CONFIG, scaleConfigProblem, type ScaleConfig } from '@ims/core'
import type { JsonValue } from '@ims/data'

/** The stored layout, or null when none is set (or it no longer makes sense). */
export function readScaleConfig(value: JsonValue | null | undefined): ScaleConfig | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const num = (v: JsonValue | undefined, fallback: number) =>
    typeof v === 'number' && Number.isInteger(v) ? v : fallback
  const config: ScaleConfig = {
    prefixes: Array.isArray(value.prefixes)
      ? value.prefixes.filter((p): p is string => typeof p === 'string')
      : DEFAULT_SCALE_CONFIG.prefixes,
    itemDigits: num(value.itemDigits, DEFAULT_SCALE_CONFIG.itemDigits),
    valueDigits: num(value.valueDigits, DEFAULT_SCALE_CONFIG.valueDigits),
    value: value.value === 'price' ? 'price' : 'weight',
    decimals: num(value.decimals, DEFAULT_SCALE_CONFIG.decimals),
  }
  return scaleConfigProblem(config) ? null : config
}

export function scaleConfigJson(config: ScaleConfig): JsonValue {
  return { ...config, prefixes: [...config.prefixes] }
}

/** "21, 22" → ["21", "22"]. */
export function parsePrefixes(text: string): string[] {
  return [...new Set(text.split(/[\s,]+/).filter(Boolean))]
}
